module.exports = __webpack_public_path__ + "img/reportPrimary.c83f5238.png";